export const _copy = () => {
	const buttons = document.querySelectorAll('.copy-link');

	if ( buttons ) {
		buttons.forEach((button) => {
			button.addEventListener('click', () => {
				let cpLink = window.location.href;
				navigator.clipboard.writeText(cpLink);
				setTimeout( () => alert('Link copied.'), 300)
			})
		})
	}
}
